export const normalizeDeletedUser = (payload) => {
  if (!payload) {
    return payload;
  }

  const normalizeUser = (user) => {
    if (!user || !user.deletedAt || !user.name) {
      return user;
    }

    return {
      ...user,
      name: user.name.endsWith('(탈퇴)') ? user.name : `${user.name}(탈퇴)`,
    };
  };

  const normalizeRows = (rows) => {
    if (!Array.isArray(rows)) {
      return rows;
    }

    return rows.map((row) => {
      if (!row || !row.user) {
        return row;
      }

      return {
        ...row,
        user: normalizeUser(row.user),
      };
    });
  };

  if (payload.list && payload.list.rows) {
    return {
      ...payload,
      list: {
        ...payload.list,
        rows: normalizeRows(payload.list.rows),
      },
    };
  }

  if (payload.charityList && payload.charityList.rows) {
    return {
      ...payload,
      charityList: {
        ...payload.charityList,
        rows: normalizeRows(payload.charityList.rows),
      },
    };
  }

  if (payload.data && Array.isArray(payload.data)) {
    return {
      ...payload,
      data: normalizeRows(payload.data),
    };
  }

  return payload;
};
